import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import { HashLink } from 'react-router-hash-link';

class Depressants extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {
        return (
            <div>
                <Navbar head="Prescription Depressants" />
                <div className="container" style={{ marginTop: "60px" }}>
                    <HashLink to='/faq#depressants'>
                        <button id="myBtn" title="FAQ">
                            <i class="fas fa-info-circle faqicon"></i>
                            <p>  FAQ</p>
                        </button>
                    </HashLink>

                    <div className="row justify-content-center">
                        <div className="col-12 text-center ">
                        <img className="img-fluid" src="/assests/images/educationDepressants.png" alt="depressants">
                        </img>
                        
                        </div>
                    </div>

                    <div className="content">
                        <h2>
                            What are Depressants?
                    </h2>
                        <p>
                            Depressants, or ‘downers’ include sedatives, tranquilizers, and hypnotics, and are substances that help relax the mind and body, decreasing brain activity.
                            They help in inducing sleep, relaxing muscles, reducing anxiety, and preventing seizures.
                            Examples of depressants include Valium and Xanax, which are Benzodiazepines; Ambien and Sonata, or Non Benzodiazepines Sedative Hypnotics; and Luminal and Nembutal- Barbiturates.
        
        
                    </p>
                       
                        <p> Most depressants are found in the form of pills or capsules, but are also available in liquid form. </p>

                        <p>Prescription depressants work by increasing the amount of GABA, a chemical in the body which inhibits brain activity, resulting in slowing down the reaction time between the mind and the body. Because of this, depressants leave users drowsy and sleepy.</p>
                       

                        



                        <h4>Effects</h4>
                        <ul>
                            <li><p>Poor concentration</p></li>
                            <li><p>Confusion</p></li>
                            <li><p>Headache</p></li>
                            <li><p>Lightheadedness and dizziness </p></li>
                            <li><p>Dry mouth</p></li>
                            <li><p>Problems with memory </p></li>
                            <li><p>Low blood pressure</p></li>
                            <li><p>Slowed breathing</p></li>
                            <li><p>Overdose</p></li>
                            
                        </ul>

                        
                    </div>
                </div>
            </div>
        )
    }
}

export default Depressants;